// base
import React from 'react';

// style
import { StyledPageTitle } from './style';

interface PageTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  active?: string;
  borderUnderline?: boolean;
}

export const PageTitle: React.FC<PageTitleProps> = ({
  title,
  active = '',
  borderUnderline = true
}) => {
  return (
    <StyledPageTitle $borderUnderline={borderUnderline} className={active}>
      <p>{title}</p>
    </StyledPageTitle>
  );
};
